import React, {Component} from 'react';
import '../../local_node_modules/react-select/dist/react-select.css';
import Alert from "react-s-alert";
import {Alert as Alert2, Button, Col, Input, Label, Row} from 'reactstrap';
import Select from "../../local_node_modules/react-select"
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {isValidRequestMessage} from "../../common/componentValidation";
import DefaultModal from "../invoice/DefaultModal";
import {Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle,} from 'react-accessible-accordion';
import {request} from "../../helper/APIUtils";
import moment from "moment";
import {EntegratorIdentifiers} from "../../helper/enums";
import {EntegratorConf} from "../../constants";

class RequestMessageModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},
			requestMessage: null,
			requestMessages: [],
			services: [],
			saveLoading: false,
			user: [],
			isMobile : window.innerWidth > 991 ? false : true
		};
		this.isOpen 			= this.isOpen.bind(this);
		this.onChange 			= this.onChange.bind(this);
		this.checkValue 		= this.checkValue.bind(this);
		this.sendRequestMessage = this.sendRequestMessage.bind(this);
	}

	componentWillMount() {
		this.setState({modal: this.props.modal});
		let self = this;
		let params = {
			url:"/requestmessage/getRequestMessage"+ (self.props.recordId ? "":"s"),
			method: "post",
            data:self.props.recordId
		};
		self.setState({loading: true});
		request(params)
		.then(function (response) {
			let data = response.data;
            let services = data.services;
            services.push({ublCode:"Diğer",ublName:"DIGER"});
			if(self.props.recordId){
                let requestMessage = data.requestMessage;
                self.setState({requestMessage, services});
            }else{
                let requestMessages = data.requestMessages;
                self.setState({requestMessages, services});
			}
		}).catch(function (error) {
			showAxiosError(error);
		}).then(function () {
			self.setState({loading: false});
		});
		let paramemeters = {
			url:"/user/getAssignee",
			method: "post",
		};
		self.setState({loading: true});
		 request(paramemeters)
			.then(function (response) {
				let data = response.data;
				self.setState({user:data});
			}).catch(function (error) {
				showAxiosError(error);
			});
	}

	sendRequestMessage(e) {
		e.preventDefault();
		let requestMessage = deepCopyObject(this.state.requestMessage);
		let result = isValidRequestMessage(requestMessage);
		let valid = result.valid;
		if (valid) {
			let self = this;
			let params = {
				url:"/requestmessage/save",
				method: "post",
				data:self.state.requestMessage
			};
			self.setState({saveLoading: true});
			request(params)
			.then(function (response) {
				Alert.success(self.props.recordId ? "Cevap başarılı şekilde verildi." :"Talebiniz başarılı şekilde alındı.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
				let data = response.data;
				if(self.props.recordId){
                    self.setState({requestMessage:data});
                }else{
                    self.setState({requestMessages:data.requestMessages,requestMessage:null});
                }
			}).catch(function (error) {
				showAxiosError(error);
			}).then(function () {
				self.setState({saveLoading: false});
			});
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			this.setState({saveLoading:false});
		}
	}

	onChange(e) {
		let requestMessage = deepCopyObject((this.state.requestMessage ? this.state.requestMessage : {}));
		requestMessage[e.name] = e.value;
		this.setState({requestMessage});
	}

	isOpen() {
		this.props.listener(this.props.requestMessage);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.requestMessage !== nextProps.requestMessage) {
			this.setState({requestMessage: nextProps.requestMessage});
		}
	}

	checkValue(key){
		if(key === "user"){
			if(this.state.requestMessage && this.state.requestMessage[key] && this.state.requestMessage[key]["recordId"]){
				return (this.state.requestMessage[key]["recordId"]);
			}else{
				return ((this.state.requestMessage && this.state.requestMessage[key]) ? this.state.requestMessage[key] :  "");
			}
		}else{
			return ((this.state.requestMessage && this.state.requestMessage[key]) ? this.state.requestMessage[key] :  "");
		}
	}

	render() {
		const {isMobile} = this.state;
		return (
			<DefaultModal
				disabled={this.state.saveLoading}
				isOpen={this.props.modal}
				title="Öneri/Talep Bildirimi"
				size="lg"
				confirmBtnText={this.props.recordId ? "Kaydet":""}
				cancelBtnText="Kapat"
				onConfirm={this.props.recordId ?  this.sendRequestMessage : this.isOpen}
				onCancel={this.isOpen}>
				<Col sm="12">
					<Col sm="12" style={{border: "2px solid #e7e7e7", borderRadius: "6px 6px 6px 6px"}}>
						<Row style={{paddingTop:"10px"}}>
							<Col sm="12" lg="3">
								<Label>Konu Tipi:</Label>
								<Select
									clearable={false}
									placeholder="Konu Seçiniz.."
									noResultsText="Kayıt Bulunamadı.."
									className="select-control"
									value={this.checkValue("subjectType")}
									onChange={(e)=>e && this.onChange({name:"subjectType",value:e.value})}
									options={this.state.services.map(service => ({
										value: service.ublName,
										label: service.ublCode
									}))}
								/>
							</Col>

							{ ((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier || EntegratorIdentifiers.SMART === EntegratorConf.identifier) && (this.props.adminUser)) ?
								<Col sm={isMobile ? 12 : 0}>
								<Col sm="12" lg="6" className={isMobile ? "p-0" : ""}>
								<Label>Konu:</Label>
								<Input type="text"
								autoComplete={"false"}
								value={this.checkValue("subject")}
								onChange={(e)=>this.onChange({name:"subject",value:e.target.value})}/>
								</Col>
								<Col sm="12" lg="6" className={isMobile ? "p-0" : ""}>
								<Label>Atanan kişi:</Label>
								<Select
								clearable={false}
								placeholder="Atanan kişiyi Seçiniz.."
								noResultsText="Kayıt Bulunamadı.."
								className="select-control"
								value={this.checkValue("user")}
								onChange={(e)=>e && this.onChange({name:"user",value:e.value})}
								options={this.state.user.map(assignee => ({
								value: assignee.recordId,
								label: assignee.firstName + " " + assignee.lastName
							}))}
								/>
								</Col>
								</Col>
							:
								<Col sm="12" lg="9">
								<Label>Konu:</Label>
								<Input type="text"
								autoComplete={"false"}
								value={this.checkValue("subject")}
								onChange={(e)=>this.onChange({name:"subject",value:e.target.value})}/>
								</Col>
							}

							<Col sm="12" style={{paddingTop:"10px"}}>
								<Label>Açıklama:</Label>
								<textarea
									   rows="4"
									   value={this.checkValue("message")}
									   style={{width:'100%', paddingBottom:'inherit'}}
									   onChange={(e)=>this.onChange({name:"message",value:e.target.value})}/>
							</Col>
							<Col sm={isMobile ? 12 : 0}>
								<Col sm="12" lg="6" className={isMobile ? "p-0" : ""}>
									<Label>Telefon Numarası:</Label>
									<Input type="text"
										   autoComplete={"false"}
										   placeholder={"xxxxxxxxx"}
										   value={this.checkValue("phone")}
										   onChange={(e)=>this.onChange({name:"phone",value:e.target.value})}/>
								</Col>
								<Col sm="12" lg="6" className={isMobile ? "p-0" : ""}>
									<Label>eMail:</Label>
									<Input type="text"
										   autoComplete={"false"}
										   placeholder={"birisi@eposta.com"}
										   value={this.checkValue("email")}
										   onChange={(e)=>this.onChange({name:"email",value:e.target.value})}/>
								</Col>
							</Col>

                            {this.props.recordId &&
                                <Col sm="12" style={{paddingTop:"10px"}}>
                                    <Label>Cevap:</Label>
                                    <textarea
                                           rows="5"
                                           value={this.checkValue("answer")}
                                           style={{width:'100%', paddingBottom:'inherit'}}
                                           onChange={(e)=>this.onChange({name:"answer",value:e.target.value})}/>
                                </Col>
                            }
                            {!this.props.recordId &&
                                <Col sm="12">
                                    <Button className="TekBtn gonder btn-default btn-md"
                                            style={{float:"right"}}
                                            disabled={this.state.saveLoading}
                                            onClick={this.sendRequestMessage}>Talep/İstek Gönder</Button>
                                </Col>
                            }
						</Row>
					</Col>
                    {!this.props.recordId && this.state.requestMessages.length>0 &&
                        <Col sm="12" style={{paddingBottom:"10px",
                                             marginTop:"10px",
                                             border: "2px solid #e7e7e7",
                                             borderRadius: "6px 6px 6px 6px"}}>
                            <h5 style={{marginLeft:"10px", marginTop:"10px", textTransform:"none"}}>Öneri/Talep Takibi</h5>
                            <Accordion>
                                {this.state.requestMessages.map((requestMessage, index) =>
                                    <AccordionItem key={"accordion-item-"+index}>
                                        <AccordionItemTitle className="accordion__title">
                                            <h6 className="u-position-relative"
                                                style={{margin:"0px",marginLeft:"10px", textTransform:"none"}}>{(index+1) +". " +requestMessage.subject+" - "+ requestMessage.statusMessage}
                                                <div className="accordion__arrow" role="presentation" />
                                            </h6>
                                        </AccordionItemTitle>
                                        <AccordionItemBody>
                                            <Alert2 style={{backgroundColor: "#f8d7da", borderColor: "#f5c6cb",color:"#155724",padding:"8px"}}>
                                                <h4 className="alert-heading">Talep/Öneri:<p style={{float:"right"}}>{requestMessage.createdAt ?  moment(requestMessage.createdAt).format("DD-MM-YYYY HH:mm"):""}</p></h4>
                                                {requestMessage.message}
                                            </Alert2>
                                            <Alert2 style={{backgroundColor: "#d4edda", borderColor: "#c3e6cb",color:"#155724",padding:"8px"}}>
                                                <h4 className="alert-heading">Cevap:<p style={{float:"right"}}>{(requestMessage.answerAt ? moment(requestMessage.answerAt).format("DD-MM-YYYY HH:mm"):"")}</p></h4>
                                                {requestMessage.answer ? requestMessage.answer : "Talebiniz gözden geçiriliyor."}
                                            </Alert2>

                                        </AccordionItemBody>
                                    </AccordionItem>)
                                }
                            </Accordion>
                        </Col>
                    }
				</Col>
			</DefaultModal>
		);
	}
}

export default RequestMessageModal;

